import { useMemo, useState } from 'react';
import { SearchIcon } from '../Icons';
import { Input, AutoComplete } from 'antd';
import styles from './styles.module.scss';
import classNames from 'classnames';

export interface TagAutocompleteProps {
  ddOptions: {
    value: number;
    label: string;
  }[];
  handleOptionsSelection: Function;
  placeholder: string;
  useOptionsValues: number[];
  allowCreation: boolean;
}

export const Autocomplete = (props: TagAutocompleteProps) => {
  const { ddOptions, handleOptionsSelection, placeholder, useOptionsValues, allowCreation } = props;
  const [openMenu, setOpenMenu] = useState<boolean>(false);
  const [searchText, setSearchText] = useState<string>('');

  const filteredOptions = useMemo(() => {
    const matches = (
      ddOptions?.filter((item) => !useOptionsValues.includes(item.value)) ?? []
    ).filter((opt) => opt.label.toLowerCase().includes(searchText.toLowerCase()));

    if (matches.length > 0) {
      return [
        {
          label: searchText ? 'Search Results' : 'Options',
          options: matches.map((item) => ({
            value: item.value,
            label: (
              <span className={styles.tagOption} style={{ padding: 10 }}>
                <SearchIcon />
                <span>{item.label}</span>
              </span>
            ),
          })),
        },
      ];
    } else if (allowCreation)
      return [
        {
          label: searchText ? 'Create' : 'No Results',
          options: searchText
            ? [
                {
                  value: searchText,
                  label: (
                    <span className={styles.tagOption} style={{ padding: 10 }}>
                      <SearchIcon />
                      <span>{searchText}</span>
                    </span>
                  ),
                },
              ]
            : [],
        },
      ];

    return [];
  }, [ddOptions, searchText, allowCreation]);

  const handleSearch = (val) => {
    setSearchText(val);
    setOpenMenu(true);
  };

  const handleSelection = (val, option) => {
    handleOptionsSelection(val);
    setSearchText('');
    setOpenMenu(false);
  };

  return (
    <div testid="autocomplete_dropdown" className={styles.autocompleteWrapper}>
      <AutoComplete
        open={openMenu}
        onSearch={handleSearch}
        onSelect={handleSelection}
        bordered
        className={styles.autocompleteContainer}
        popupClassName={classNames(
          styles.suggestionPopupContainer,
          !filteredOptions?.length ||
            (filteredOptions?.length === 1 && filteredOptions[0].label === 'No Results')
            ? styles.popupRadiusSmall
            : styles.popupRadiusLarge,
        )}
        notFoundContent={<p>No Results</p>}
        options={filteredOptions}
        onClick={() => setOpenMenu(true)}
        onBlur={() => setOpenMenu(false)}
        value={searchText}
      >
        <Input
          className={styles.autocompleteInput}
          prefix={<SearchIcon />}
          placeholder={placeholder}
        />
      </AutoComplete>
    </div>
  );
};
